// extracted by css-extract-rspack-plugin
export default {"conversationListHeading":"ConversationList-module__conversationListHeading__slzxM","inner":"ConversationList-module__inner__L8P9A"};